import { render, staticRenderFns } from "./around.vue?vue&type=template&id=901df456&scoped=true&"
import script from "./around.vue?vue&type=script&lang=js&"
export * from "./around.vue?vue&type=script&lang=js&"
import style0 from "./around.vue?vue&type=style&index=0&id=901df456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901df456",
  null
  
)

export default component.exports